import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import process from './process'
import preset from './preset'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,process,preset
  }
})
